import {createSelector} from '@reduxjs/toolkit';

import {
  CONFIGS as filtersConfig,
  hasChangedFromDefaults,
} from '../util/filters.js';

export const getFilterValues = state => state.filters;

export const getFiltersObj = createSelector([getFilterValues], filterValues =>
  Object.keys(filterValues).reduce((filters, filterKey) => {
    filters[filterKey] = {
      ...filtersConfig[filterKey],
      values: filterValues[filterKey],
    };

    return filters;
  }, {})
);

export const getUpdatedFilters = createSelector([getFiltersObj], filters =>
  Object.values(filters).filter(filter => hasChangedFromDefaults(filter))
);
